//  Product Page Readmore Button start

  document.addEventListener('DOMContentLoaded', function () {
    const desc = document.querySelector('.product-prestige-description');
    if (!desc) return;

    const closedHeight = 90;

    // Check if description is long enough to need a button
    if (desc.scrollHeight <= closedHeight + 20) return;

    // Initial Setup
    desc.style.setProperty('height', closedHeight + 'px', 'important');
    desc.style.setProperty('overflow', 'hidden', 'important');
    desc.style.setProperty('max-height', 'none', 'important');
    desc.style.setProperty('transition', 'height 0.6s ease', 'important');

    const btn = document.createElement('button');
    btn.className = 'product-read-more-btn';
    btn.type = 'button';
    btn.innerHTML = 'Read more <span>+</span>';

    desc.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      const isOpen = desc.classList.contains('is-open');

      if (!isOpen) {
        // OPENING
        desc.classList.add('is-open');

        desc.style.setProperty(
          'height',
          desc.scrollHeight + 'px',
          'important'
        );

        btn.innerHTML = 'Read less <span>−</span>';

        setTimeout(() => {
          if (desc.classList.contains('is-open')) {
            desc.style.setProperty(
              'height',
              'auto',
              'important'
            );
          }
        }, 600);

      } else {
        // CLOSING
        desc.style.setProperty(
          'height',
          desc.scrollHeight + 'px',
          'important'
        );

        desc.offsetHeight;

        desc.classList.remove('is-open');

        desc.style.setProperty(
          'height',
          closedHeight + 'px',
          'important'
        );

        btn.innerHTML = 'Read more <span>+</span>';
      }
    });
  });
//  Product Page Readmore Button end